import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import Element_Map_Marker from './Element_Map_Marker';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';

// import { useAuth } from '../Contexts/AuthContext';




export default function Render_Map({ Map_Composition, Selected_Building, Selected_Floor, Floor_Set }) {
    // const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);
    const { Map_Time_Parameters } = useMapRenderer();
    const { Status_Fetching_Set, Status_Saving_Set } = useStatus();
    const [Layer_Loading, Layer_Loading_Set] = useState("Loading");
    const { Room_State_Get } = useScheduleManagement();



    useEffect(() => {
        const OnRadioSelect = ({ ID_Parent, ID_ActiveButton, ID_ActiveButton_Index }) => {
            Floor_Set(ID_ActiveButton_Index);
        }

        Layer_Loading_Set("Loading");

        UI.on("Radio_Selected", OnRadioSelect);
        return () => {
            UI.off("Radio_Selected", OnRadioSelect);
        }
        
    }, []);

    const handleImageLoad = () => {
        Layer_Loading_Set("Done");
    }

    const Selected_Building_Index = Map_Composition.findIndex(
        (Building) => Building.Name === Selected_Building
    );


    return (
        <div className='Renderer_Map'>
            <div className='Renderer_Map_Content'>
                {Map_Composition[Selected_Building]?.Floors?.length > 0 ?
                    <>
                        {Map_Composition[Selected_Building].Floors.map((Layer, index) => {
                            const ID = `Controls_Map_Floor_${Layer.Name.Shortened}`;
                            const IsActive = index == Selected_Floor;
                            return (
                                <div className='Renderer_Map_Layer' State={IsActive ? "Active" : "Inactive"}>
                                    <img src={Layer.Plan.FileURL} className='Renderer_Map_Layer_Image' draggable='false' loading='lazy' State={Layer_Loading} onLoad={() => handleImageLoad()} />
                                    <div className='Renderer_Map_Layer_Markers'>
                                        {Layer.Rooms.map((Room) => {
                                            const state = Room_State_Get(Room._id, Map_Time_Parameters.Date, Map_Time_Parameters.Time_Start, Map_Time_Parameters.Time_End, Room);
                                            return (
                                                <Element_Map_Marker
                                                    key={Room._id}
                                                    id={Room._id}
                                                    x={Number(Room.Location.Coordinates.X)}
                                                    y={Number(Room.Location.Coordinates.Y)}
                                                    Label_Room={Room.Name}
                                                    Label_State={state}
                                                    State={state}
                                                />
                                            )
                                        })}


                                    </div>
                                </div>
                            )
                        })}
                    </>
                    :
                    ""
                }

            </div>
        </div>
    );

}


